import type { CheckboxProps } from "@mui/material";
import { Checkbox } from "src/components/Checkbox/Checkbox.tsx";
import React from "react";

export const DataGridCheckbox = (props: CheckboxProps) => {
  const {
    onChange,
    inputRef,
    checked,
    indeterminate,
    disabled,
    name,
    onClick,
  } = props;

  return (
    <Checkbox
      disabled={disabled}
      // Шапка при частичном выборе: MUI передаёт indeterminate отдельно от checked.
      checked={indeterminate ? "indeterminate" : checked}
      name={name}
      onChange={(e) => onChange?.(e, e.currentTarget.checked)}
      onClick={(e) => {
        // the onClick event is used in the column management panel to toggle column visibility
        // if you remove the onClick handler then the checkbox won't toggle
        // I don't know why MUI developers didn't use the onChange event for this

        onClick?.(
          // @ts-ignore
          e,
        );
      }}
      ref={inputRef}
    />
  );
};
